export default "__VITE_ASSET__CB_QSns8__"